import api from "../../Services/api";
import React, { useEffect, useState } from "react";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import { useOperador } from "../../Hooks/useOperador";
import { operadorTemCargo } from "../../Utils/cargos";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import GridRegistros from "../../Componentes/GridRegistros";
import { FaToggleOff, FaToggleOn } from "react-icons/fa";
import "./index.css";

const CadOperador = () => {
  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [situacao, setSituacao] = useState(1);

  const [cargos, setCargos] = useState([]);
  const [idCargoSelecionado, setIdCargoSelecionado] = useState("");

  const [operadores, setOperadores] = useState([]);
  const { IDOperador, nome: nomeOperador, operador, permissaoPrincipal } = useOperador();
  const usuarioAdministrador = Number(permissaoPrincipal) === 99 ||
    operadorTemCargo(operador, "Administrador");
  const [idOperadorEditando, setIdOperadorEditando] = useState(null);

  const navigate = useNavigate();

  let idFormatado = String(IDOperador).padStart(6, '0');

  useEffect(() => {
    if (!operador) {
      navigate("/");
    }
    carregarCargos();
  }, [operador]);

  useEffect(() => {
    const fetchOperadores = async () => {
      const response = await api.get('/operadores');
      setOperadores(response.data);
    };
    fetchOperadores();
  }, []);

  const carregarOperadores = async () => {
    try {
      const res = await api.get("/operadores");
      setOperadores(res.data);
    } catch (err) {
      console.error("Erro ao carregar operadores", err);
      exibirErrosValidacao(err, "Erro ao carregar operadores");
    }
  };

  const carregarCargos = async () => {
    try {
      const res = await api.get("/cargos");
      setCargos(res.data);
    } catch (err) {
      console.error("Erro ao carregar cargos", err);
      exibirErrosValidacao(err, "Erro ao carregar cargos");
    }
  };

  const handleEdit = async (operador) => {
    setIdOperadorEditando(operador.IDOperador);
    setNome(operador.nome);
    setCpf(operador.cpf);
    setEmail(operador.email);
    setSenha(operador.senha);
    const nascimento = String(operador.dataNascimento || "");
    const partesNascimento = nascimento.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    setDataNascimento(
      partesNascimento
        ? `${partesNascimento[3]}-${partesNascimento[2]}-${partesNascimento[1]}`
        : nascimento.slice(0, 10)
    );
    setSituacao(operadorEstaAtivo(operador) ? 1 : 0);

    try {
      const res = await api.get("/operadorcargo/" + operador.IDOperador);
      if (res.status === 200 && res.data?.Cargos?.length > 0) {
        setIdCargoSelecionado(res.data.Cargos[0].IDCargo);
      }
    } catch (err) {
      console.error("Erro ao buscar cargo do operador:", err);
      Swal.fire("Erro ao carregar o cargo do operador para ediÃ§Ã£o.");
    }
  };

  const exibirErrosValidacao = (err, titulo = "Erro") => {
    const bodyErrors = err.response?.data?.erros?.body;

    if (bodyErrors) {
      const mensagens = Object.entries(bodyErrors)
        .map(([campo, msg]) => `<b>${campo}</b>: ${msg}`)
        .join("<br>");

      Swal.fire({
        title: titulo,
        html: mensagens,
        icon: "error"
      });
    } else {
      const mensagem =
        err.response?.data?.message ||
        err.response?.data?.errors?.default ||
        "Erro inesperado ao processar requisiÃ§Ã£o.";

      Swal.fire(titulo, mensagem, "error");
    }
  };


  const salvarOperador = async () => {
    if (!nome || !cpf || !email || !senha || !idCargoSelecionado) {
      Swal.fire("Preencha todos os campos.");
      return;
    }

    const cpfSemMascara = String(cpf || "").replace(/\D/g, "");
    if (cpfSemMascara.length !== 11) {
      Swal.fire("CPF invalido", "O CPF deve conter 11 digitos.", "warning");
      return;
    }

    let IDOperador = idOperadorEditando;

    const formatDate = (date) => date.toISOString().split("T")[0];
    const novoOperador = {
      nome,
      cpf: cpfSemMascara,
      email,
      senha,
      situacao,
      dataCadastro: formatDate(new Date()),
      dataExpiracao: formatDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1))),
      dataNascimento: dataNascimento || null,
    };

    try {
      if (idOperadorEditando) {
        const resAtualizacao = await api.put(`/operador/${IDOperador}`, novoOperador);
        if (resAtualizacao.status !== 201) {
          Swal.fire("Erro ao atualizar operador.");
          console.log(resAtualizacao);
          return;
        }
      } else {
        const resCriacao = await api.post("/operador", {
          ...novoOperador,
        });
        if (resCriacao.status === 201 && resCriacao.data.IDOperador) {
          IDOperador = resCriacao.data.IDOperador;
        } else {
          console.log(resCriacao);
          Swal.fire("Erro ao cadastrar operador.");
          return;
        }
      }

      // Apaga relaÃ§Ã£o anterior operador-cargo
      try {
        await api.delete(`/operadorcargoidoperador/${IDOperador}`);
      } catch (err) {
        if (err.response?.status !== 404) {
          console.error("Erro ao tentar deletar operador-cargo:", err);
          exibirErrosValidacao(err, "Erro ao tentar deletar operador-cargo");
          return;
        }
        // Se for 404, ignora e segue
      }

      // Insere nova relaÃ§Ã£o operador-cargo
      const resVinculo = await api.post("/operadorcargo", {
        IDOperador,
        IDCargo: idCargoSelecionado
      });

      if (resVinculo.status === 201) {
        Swal.fire("Operador salvo e cargo vinculado com sucesso!");
      } else {
        Swal.fire("Erro ao vincular operador ao cargo.");
      }

      // Limpa os campos
      setIdOperadorEditando(null);
      setNome("");
      setCpf("");
      setEmail("");
      setSenha("");
      setDataNascimento("");
      setSituacao(1);
      setIdCargoSelecionado("");
      await carregarOperadores();
    } catch (err) {
      console.error(err);
      exibirErrosValidacao(err, "Erro");
    }
  };

  const handleDelete = async (id) => {
    try {
      // Tenta excluir vÃ­nculos operador-processo (se existirem)
      try {
        await api.delete(`/processo/operador/${id}`);
      } catch (err) {
        if (err.response?.status !== 404) {
          console.error("Erro ao tentar deletar operador-cargo:", err);
          exibirErrosValidacao(err, "Erro ao desvincular cargo anterior");
          return;
        }
        // Se deu 404 = nÃ£o tinha vÃ­nculo â†’ segue em frente
      }

      // Tenta excluir vÃ­nculos operador-cargo (se existirem)
      try {
        await api.delete(`/operadorcargoidoperador/${id}`);
      } catch (err) {
        if (err.response?.status !== 404) {
          console.error("Erro ao tentar deletar operador-cargo:", err);
          exibirErrosValidacao(err, "Erro ao desvincular cargo anterior");
          return;
        }
        // Se deu 404 = nÃ£o tinha vÃ­nculo â†’ segue em frente
      }

      // Agora exclui o operador
      
      const res = await api.delete(`/operador/${id}`);
      if (res.status === 204) {
        Swal.fire("ExcluÃ­do!", "Operador excluÃ­do com sucesso.", "success");
        carregarOperadores();
      } else {
        Swal.fire("Erro", "Erro ao excluir operador.", "error");
      }
      
    } catch (err) {
      console.error(err);
      exibirErrosValidacao(err, "Erro");
    }
  };

  const operadorEstaAtivo = (operador) => {
    if (typeof operador.situacao === "number") return operador.situacao === 1;
    return String(operador.situacao || "").toLowerCase() === "ativo";
  };

  const alternarSituacaoOperador = async (operador) => {
    const ativo = operadorEstaAtivo(operador);
    const novaSituacao = ativo ? 0 : 1;
    const acao = ativo ? "desativar" : "ativar";

    const result = await Swal.fire({
      title: ativo ? "Desativar operador?" : "Ativar operador?",
      text: ativo
        ? "O operador desativado nao conseguira acessar o sistema."
        : "O operador voltara a conseguir acessar o sistema.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: ativo ? "Sim, desativar" : "Sim, ativar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "var(--color-btnCancelar-danger)",
      customClass: {
        cancelButton: "swal-cancel-danger",
      },
    });

    if (!result.isConfirmed) return;

    try {
      await api.put(`/operador/${operador.IDOperador}/situacao`, {
        situacao: novaSituacao,
      });
      Swal.fire(
        "Sucesso",
        `Operador ${ativo ? "desativado" : "ativado"} com sucesso.`,
        "success"
      );
      await carregarOperadores();
    } catch (err) {
      console.error(`Erro ao ${acao} operador`, err);
      exibirErrosValidacao(err, `Erro ao ${acao} operador`);
    }
  };

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={idFormatado} userName={nomeOperador} />
        <h4 style={{ width: '100%', textAlign: 'center', paddingTop: '50px' }}>CADASTRO DE OPERADORES</h4>

        <div className="container">
          <div className="form-group">
            <label>Nome</label>
            <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} />
          </div>

          <div className="row">
            <div className="form-group col-sm-6">
              <label>CPF</label>
              <input type="text" value={cpf} onChange={(e) => setCpf(e.target.value)} />
            </div>
            <div className="form-group col-sm-6">
              <label>Cargo</label>
              <select
                value={idCargoSelecionado}
                onChange={(e) => setIdCargoSelecionado(Number(e.target.value))}
              >
                <option value="">Selecione um cargo</option>
                {cargos.filter((cargo) => usuarioAdministrador ||
                  ![cargo.descricao, cargo["Descrição"], cargo["DescriÃ§Ã£o"], cargo["DescriÃƒÂ§ÃƒÂ£o"]]
                    .some((descricao) => String(descricao || "").normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "").trim().toLowerCase() === "administrador")
                ).map((cargo) => (
                  <option key={cargo.IDCargo} value={cargo.IDCargo}>
                    {cargo["Descrição"] || cargo["DescriÃ§Ã£o"]}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="row">
            <div className="form-group col-sm-4">
              <label>Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>

            <div className="form-group col-sm-2">
              <label>Senha</label>
              <input type="password" value={senha} onChange={(e) => setSenha(e.target.value)} />
            </div>

            <div className="form-group col-sm-3">
              <label>Data de nascimento (opcional)</label>
              <input
                type="date"
                value={dataNascimento}
                onChange={(e) => setDataNascimento(e.target.value)}
              />
            </div>

            <div className="form-group col-sm-3">
              <label>SituaÃ§Ã£o</label>
              <select value={situacao} onChange={(e) => setSituacao(Number(e.target.value))}>
                <option value={1}>Ativo</option>
                <option value={0}>Inativo</option>
              </select>
            </div>
          </div>

          <button onClick={salvarOperador}>Salvar Operador</button>
        </div>

        <br />
        <div>
          <GridRegistros
            registros={operadores}
            onDelete={handleDelete}
            onEdit={handleEdit}
            chaveId="IDOperador"
            exibirEditar={true}
            exibirDeletar={false}
            ocultarCampos={["senha", "dataExpiracao"]}
            renderAcoesExtra={(registro) => {
              const ativo = operadorEstaAtivo(registro);
              const IconeSituacao = ativo ? FaToggleOn : FaToggleOff;

              return (
                <IconeSituacao
                  className={`icon situacao-operador-icon ${ativo ? "ativo" : "inativo"}`}
                  onClick={() => alternarSituacaoOperador(registro)}
                  title={ativo ? "Desativar operador" : "Ativar operador"}
                />
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CadOperador;
